import shared from './shared'
import store from '../store'
import { AnswerUtils } from '../utils/answerUtils'

export default {
    shared,
    async getAnswers (quizKey) {
        try {
            const getAnswers = this.shared.functions().httpsCallable('getAnswers')
            const data = await getAnswers(quizKey)
            return data.data
        } catch (error) {
            console.error(error)
        }
    },
    async getUserAnswers () {
        try {
            const getUserAnswers = this.shared.functions().httpsCallable('getUserAnswers')
            const data = await getUserAnswers(store.state.prevRound.quizKey)
            return data.data
        } catch (error) {
            console.error(error)
        }
    },
    async getUserAnswersStatistics (uid, quizKey) {
        try {
            const getUserAnswersStatistics = this.shared.functions().httpsCallable('getUserAnswersStatistics')
            const data = await getUserAnswersStatistics({ uid, quizKey })
            return data.data
        } catch (error) {
            console.error(error)
            return false
        }
    },
    async sendAnswer (answer) {
        try {
            AnswerUtils.validateAnswerRequest(answer)
            const sendAnswer = this.shared.functions().httpsCallable('sendAnswer')
            await sendAnswer(answer)
            return true
        } catch (error) {
            console.log(error)
            return false
        }
    },
    async turnInAnswers (turnInAnswersRequest) {
        try {
            AnswerUtils.validateTurnInAnswersRequest(turnInAnswersRequest)
            const turnInAnswers = this.shared.functions().httpsCallable('turnInAnswers')
            await turnInAnswers(turnInAnswersRequest)
            return true
        } catch (error) {
            console.log(error)
            return false
        }
    }
}
